import { call, put, select } from 'redux-saga/effects';
import { Action } from '@reduxjs/toolkit';
import i18n from 'i18n';
import { addActionNotification } from 'features/notifications/action-notifications/addActionNotification';
import { signalingQuestionAnswered } from 'features/qa/actions';
import { selectSidePanel, sidePanelOpened } from 'features/side-panels/sidePanelsSlice';
import { SidePanelType } from 'features/side-panels/types';
import { Question } from 'features/qa/types';
import { selectQuestionById } from 'features/qa/qaSlice';
import { FeatureFlag } from 'features/feature-set/types';

export function* onQuestionAnsweredSaga(action: ReturnType<typeof signalingQuestionAnswered>) {
  const questionId = action.payload.question.id;
  const question: Question = yield select(selectQuestionById, questionId);
  if (!question.local || action.payload.local) {
    // only show answers to local questions
    return;
  }

  const { id, answer, user } = action.payload;

  const activePanel: SidePanelType = yield select(selectSidePanel);

  const actionNotificationThunk: Action = yield call(
    addActionNotification,
    {
      content: i18n.t('notifications:qa.local_question_answered.content', {
        username: user.name,
        answer,
      }),
      okText: i18n.t('notifications:qa.local_question_answered.btn_ok_label'),
      okAction: sidePanelOpened('qa', {
        questionId,
      }),
      hideOkAction: activePanel === 'qa',
      initiatorId: user.id,
      scope: [FeatureFlag.qa, 'text-answer'],
      data: {
        questionId,
      },
    },
    {
      toastId: `${questionId}_${id}`,
    }
  );

  yield put(actionNotificationThunk);
}
